var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCydea = function SvgCydea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 59,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cydea_svg__a)",
    d: "M24.654 37.633q.936 0 1.587.68.68.653.68 1.587 0 .935-.708 1.672-4.392 3.825-10.344 3.826-6.574 0-11.222-4.648T0 29.528t4.647-11.222Q9.296 13.66 15.87 13.66q5.952 0 10.344 3.826.793.708.793 1.757 0 .935-.68 1.615a2.16 2.16 0 0 1-1.587.652q-.822 0-1.445-.51-3.173-2.806-7.425-2.806-4.704 0-8.02 3.316t-3.315 8.02q0 4.703 3.316 8.019t8.02 3.316q4.25 0 7.396-2.777.595-.454 1.388-.454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cydea_svg__b)",
    d: "M42.876 43.102 31.994 16.975a2.2 2.2 0 0 1-.255-1.049q0-.934.652-1.587.68-.68 1.615-.68t1.615.652q.369.396.538.85l9.182 22.019 9.182-22.02q.17-.452.566-.85a2.16 2.16 0 0 1 1.587-.651q.936 0 1.587.68.68.652.68 1.587 0 .567-.255 1.048l-16.89 40.524a2.3 2.3 0 0 1-.538.822q-.68.68-1.615.68a2.2 2.2 0 0 1-1.615-.68 2.16 2.16 0 0 1-.652-1.587q0-.566.255-1.049z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cydea_svg__c)",
    d: "M90.682 29.528q0-4.704-3.315-8.02t-8.02-3.315-8.02 3.316-3.315 8.02q0 4.703 3.315 8.019t8.02 3.316q4.704 0 8.02-3.316t3.315-8.02m0-27.26q0-.936.652-1.588.68-.68 1.615-.68.936 0 1.587.68.68.653.68 1.587v27.261q0 6.575-4.647 11.222-4.649 4.648-11.222 4.648-6.575 0-11.222-4.648-4.648-4.647-4.648-11.222t4.648-11.222 11.222-4.647 11.222 4.647l.113.114z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cydea_svg__d)",
    d: "M126.756 27.261q-.623-3.258-3.117-5.752-3.315-3.315-8.019-3.316t-8.02 3.316q-2.495 2.493-3.117 5.752zm-2.408 10.429q.934 0 1.587.68.68.651.68 1.587t-.652 1.615q-4.392 3.825-10.343 3.826-6.575 0-11.222-4.648-4.648-4.647-4.648-11.222t4.648-11.222 11.222-4.647 11.221 4.647q4.648 4.649 4.648 11.222 0 .935-.68 1.616a2.16 2.16 0 0 1-1.587.651h-24.739q.622 3.259 3.117 5.753 3.315 3.316 8.02 3.316 4.25 0 7.311-2.692a2.26 2.26 0 0 1 1.417-.482"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cydea_svg__e)",
    d: "M151.892 18.193q-4.704 0-8.019 3.316t-3.316 8.02q0 4.703 3.316 8.019t8.019 3.316q4.704 0 8.02-3.316t3.316-8.02-3.316-8.02-8.02-3.315m11.336 22.444q-4.761 4.76-11.336 4.76-6.574 0-11.221-4.647t-4.648-11.222q0-6.574 4.648-11.222t11.221-4.647q6.575 0 11.222 4.647 4.648 4.649 4.648 11.222v13.603q0 .934-.68 1.615a2.16 2.16 0 0 1-1.587.652 2.26 2.26 0 0 1-1.616-.652 2.26 2.26 0 0 1-.651-1.615z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__a",
    x1: 0,
    x2: 127.225,
    y1: 0,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__b",
    x1: 0,
    x2: 127.225,
    y1: 0,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__c",
    x1: 0,
    x2: 127.225,
    y1: 0,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__d",
    x1: 0,
    x2: 127.225,
    y1: 0,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__e",
    x1: 0,
    x2: 127.225,
    y1: 0,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })))));
};
export { SvgCydea as ReactComponent };
export default __webpack_public_path__ + "static/cydea.482dd601.svg";